import {
  Component,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BadgeService, BadgeNotification } from '@schoolbelle/api/badge';
import { groupBy, values, mapValues, maxBy } from 'lodash-es';

export class AbstractNotificationListComponent implements OnInit {
  protected subscription = new Subscription();
  notificationList:(BadgeNotification&{cnt:number})[] = [];
  badgeTotal:number = 0;
  constructor(
    protected badge:BadgeService,
    protected cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.badge.onListChange.subscribe(list=>{
        this.notificationList = this.groupNotificationList(list);
        this.badgeTotal = this.badge.badges.total;
        this.cdRef.detectChanges();
      })
    )  
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * only one of the notifications for the same letter sent to multiple classes has msg and content.
   * should fill the msg and content of the other notifications
   * @param li 
   * @param list 
   */
  protected fillMsgAndContent (li:BadgeNotification, list:BadgeNotification[]) {
    if(![
      'letter_to_group.insert',
      'comment.insert', // temporary
    ].includes(li.action)) return li;
    const letter_id = li.new && li.new.letter_id;
    if (!letter_id) return li;
    if (li.msg || li.content) return li;

    const groupByKey = this.getGroupByLetterId(li);
    const letter_noti = list.find(li=>groupByKey === this.getGroupByLetterId(li) && (li.msg || li.content) ? true : false);
    if (!letter_noti) return li;
    const { msg, content } = letter_noti;
    return {...li, msg, content };
  }
  protected getGroupByLetterId (li:BadgeNotification) {
    return `${li.action}-${li.new && li.new.letter_id}`;

  }
  protected getGroupByKey (li:BadgeNotification) {
    return `${li.group_id}-${li.action}-${li.new && li.new.type}-${li.new && li.new.ltg_id}`;
  }

  isNew (li:BadgeNotification) {
    return this.badge.shouldAddToBadge(li);
  }
  protected groupNotificationList (list:BadgeNotification[] = []):Array<BadgeNotification&{cnt:number}> {
    /**
     * notification 리스트에서 사일런트 푸시를 제외
     * 사일런트 푸시는 content와 msg가 없음
     */
    list = list.filter(li => li.content || li.msg);

    const grouped = groupBy(list, li=>this.getGroupByKey(li));

    return values(mapValues(grouped, (grouped_list)=>{
      const latest = maxBy(grouped_list, 'notification_id');
      const filled = this.fillMsgAndContent(latest, list);

      return {
        ...filled, 
        read:grouped_list.find(li=>li.read === 0) ? 0 : 1 as 0|1,
        cnt:grouped_list.length,
        
      };
    }))
    // temp fix for server error
    .filter(li=>{
      if (li.action === 'comment.insert' && !(li.msg || li.content)) return false;
      return true;
    });
    // temp fix for server error
  }
}